<template
  ><div>
    <div class="gs-app gm-studio" style="min-height:0;padding-bottom:0">
      <forms-nav />
      <p class="gm-muted">
        Your existing forms are here. They keep their current links,
        integrations and editor.
      </p>
    </div>
    <legacy-forms /></div
></template>
<script>
import './index';
import FormsNav from './FormsNav.vue';
import LegacyForms from '../../pages/forms/index.vue';
export default {
  middleware: 'auth',
  layout: 'defaultWithoutVuePerfectScrollbar',
  components: { FormsNav, LegacyForms }
};
</script>
